import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';
import { useAxios } from '../context/AxiosContextProvider';

export interface PromotionType {
  data: { coupon_id: string; name: string };
}

async function getPromotionType(axios: AxiosInstance): Promise<PromotionType> {
  return await axios.get(`${config.apiBaseUrl}/op/v1/promotion-type`);
}

export default function usePromotionTypesQuery() {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(),
    queryFn: () => getPromotionType(axios),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, JSON.stringify(query.error as any));
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey() {
  return ['PromotionTypes'] as const satisfies QueryKey;
}
usePromotionTypesQuery.getKey = getKey();
